import { render, staticRenderFns } from "./WCColorPicker.vue?vue&type=template&id=3bd42902&"
import script from "./WCColorPicker.vue?vue&type=script&lang=js&"
export * from "./WCColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBadge,VSelect})
